const config = {
API_BASE_URL: 'https://prenotazioni.mitconsulting.eu/api',
//API_BASE_URL: 'http://localhost/gestione_prenotazioni_multi/api',
  
  // Email
  ADMIN_EMAIL: 'info@mitconsulting.eu',   //psw admin123
  SUPPORT_EMAIL: 'info@mitconsulting.eu',
  
  // Branding
  APP_NAME: 'Gestione Prenotazioni',
  COMPANY_NAME: 'MIT Consulting',
  
    // NUOVO: Configurazione Stanze
  ROOMS: [
    {
      id: 'sala-a',
      name: 'Stanza A',
      enabled: true, // ← Abilita/disabilita questa stanza
      color: '#3b82f6', // blu
      colorLight: '#dbeafe',
      colorDark: '#1e40af',
      capacity: 5,
      description: 'Sala riunioni principale'
    },
    {
      id: 'sala-b',
      name: 'Stanza B',
      enabled: true, // ← Abilita/disabilita questa stanza
      color: '#10b981', // verde
      colorLight: '#d1fae5',
      colorDark: '#047857',
      capacity: 5,
      description: 'Sala riunioni secondaria'
    },
    {
      id: 'sala-c',
      name: 'Sala C',
      enabled: false, // ← Questa stanza è DISABILITATA
      color: '#f59e0b', // arancione
      colorLight: '#fef3c7',
      colorDark: '#d97706',
      capacity: 5,
      description: 'Sala meeting piccola'
    }
  ],  
  // Impostazioni booking
  MIN_BOOKING_DURATION: 30, // minuti
  MAX_BOOKING_DURATION: 600, // 8 ore (in minuti)
  WORKING_HOURS_START: 540, // 9:00 in minuti (9*60)
  WORKING_HOURS_END: 1155, // 19:15 in minuti (19*60 + 15)
  TIME_SLOT_INTERVAL: 15, // minuti tra slot
  
  // Regole prenotazioni
  BOOKING_CANCELLATION_HOURS: 24, // ore prima della prenotazione
  BOOKING_EDIT_HOURS: 24, // ore prima della prenotazione
  BOOKING_BUFFER_MINUTES: 15, // buffer tra prenotazioni
  
  // UI
  CELL_HEIGHT_PX: 60, // altezza celle calendario settimanale
};

export default config;